import React, {useState} from 'react';

import { Container } from '@mui/material';

import Layout from '../../components/Layout';
import Heading from '../../components/Heading';
import { HeadCard } from '../../components/Farm/HeadCard';
import { BottomSection } from '../../components/Farm/BottomSection';

const Farm = () => {
  const [farmType, setFarmType] = useState('1');
  return (
    <Layout>
      <Heading title={'farm'} />
      <Container className="main_content_wrap" maxWidth="lg">
        <HeadCard farmType={farmType} />
        <BottomSection farmType={farmType} setFarmType={setFarmType} />
      </Container>
    </Layout>
  );
};

export default Farm;
